/**
 * Jobs API
 * Backend de bolsa de trabajo para alumno, empresa y admin.  Pantallas de Alumno [P_A_xx]   https://app.axure.cloud/app/project/5t0fsq/overview  Pantallas de empresa [P_E_xx]    https://app.axure.cloud/app/project/jcj3w8/overview
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ContractType model module.
 * @module model/ContractType
 * @version v1
 */
class ContractType {
    /**
     * Constructs a new <code>ContractType</code>.
     * Tipo de contrato: Autónomo, De duración determinada, De relevo, Fijo discontinuo, Indefinido, A tiempo Parcial, Otros Contratos
     * @alias module:model/ContractType
     */
    constructor() { 
        
        ContractType.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ContractType</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ContractType} obj Optional instance to populate.
     * @return {module:model/ContractType} The populated <code>ContractType</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ContractType();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('name')) {
                obj['name'] = ApiClient.convertToType(data['name'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
ContractType.prototype['id'] = undefined;

/**
 * @member {String} name
 */
ContractType.prototype['name'] = undefined;






export default ContractType;

